export enum ContextMenuId {
  folderActions = 'folder-actions',
}
